import React, { useState } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import { List, styled } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Skeleton } from '@material-ui/lab';
import NavigationItem from './NavigationItem';
import useNavigationData from './useNavigationData';
import { getExpandedMenuByPath } from './utils';
import { useNotification } from '../../providers/notificationsProvider';

const { Sider } = Layout;
const StyledList = styled(List)({
  '& .MuiListItem-button:hover': {
    color: '#5564F8'
  },

  '& .MuiTypography-root': {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: '600'
  }
});

const MenuSkeleton = () => {
  const n = 10;
  return (
    <>
      {[...Array(n)].map((item, idx) => (
        <Skeleton
          key={idx}
          height={30}
          style={{ marginBottom: '0.5rem' }}
          width={idx % 2 === 0 ? '60%' : '80%'}
        />
      ))}
    </>
  );
};

const SideMenu = () => {
  const location = useLocation();
  const navigationData = useNavigationData();
  const [isLoading, isError] = useSelector(({ provider }) => [
    provider.isLoading,
    provider.isError
  ]);
  const [expanded, setExpanded] = useState(() =>
    getExpandedMenuByPath(navigationData, location.pathname)
  );
  const { notify } = useNotification();

  if (isError) {
    notify({ message: 'Something went wrong... please try again later' });
  }

  return (
    <Sider
      style={{
        background: 'linear-gradient(184.7deg, #F0F4FF , #ffffff)',
        height: 'calc(100vh - 155px)',
        overflow: 'auto'
      }}
      width={232}
    >
      <StyledList component="nav">
        {!isLoading ? (
          <>
            {navigationData
              .filter((item) => item.isVisible)
              .map((item) => (
                <NavigationItem
                  key={item.id}
                  expandedItems={expanded}
                  item={item}
                  setExpanded={setExpanded}
                />
              ))}
          </>
        ) : (
          <MenuSkeleton />
        )}
      </StyledList>
    </Sider>
  );
};

export default SideMenu;
